import type { ReactNode } from 'react';
import { C, POLICE_TITRE, DEGRADE_ACTION, OMBRE_ACTION } from '../../theme';
import { Micro } from '../../icones';

/** Coquille commune aux ecrans d'entree : connexion, inscription, creation de foyer. */
export function CadreAuth({
  titre,
  sousTitre,
  children,
  pied,
}: {
  titre: string;
  sousTitre?: string;
  children: ReactNode;
  pied?: ReactNode;
}) {
  return (
    <div
      style={{
        flex: '1 1 0',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 24,
        padding: '32px 24px',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}>
        <div
          style={{
            width: 64,
            height: 64,
            borderRadius: 20,
            background: DEGRADE_ACTION,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: OMBRE_ACTION,
          }}
        >
          <Micro taille={30} couleur="#FFFFFF" />
        </div>
        <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: 4 }}>
          <h1
            style={{
              margin: 0,
              fontFamily: POLICE_TITRE,
              fontWeight: 200,
              fontSize: 36,
              lineHeight: 1.1,
              letterSpacing: '-0.4px',
              color: C.encre,
            }}
          >
            {titre}
          </h1>
          {sousTitre !== undefined ? (
            <p style={{ margin: 0, fontSize: 14, color: C.secondaire, lineHeight: 1.5 }}>
              {sousTitre}
            </p>
          ) : null}
        </div>
      </div>

      {children}

      {pied !== undefined ? (
        <div style={{ textAlign: 'center', fontSize: 13.5, color: C.secondaire }}>{pied}</div>
      ) : null}
    </div>
  );
}

/** Bandeau d'erreur d'un formulaire. */
export function Alerte({ message }: { message: string }) {
  return (
    <div
      role="alert"
      style={{
        background: C.corailFond,
        border: `1px solid ${C.corailBordure}`,
        color: C.corailTexte,
        borderRadius: 12,
        padding: '12px 14px',
        fontSize: 13.5,
        fontWeight: 700,
        lineHeight: 1.45,
      }}
    >
      {message}
    </div>
  );
}

/** Lien en texte, pour basculer d'un ecran d'entree a l'autre. */
export function LienTexte({ children, onClick }: { children: ReactNode; onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        background: 'none',
        border: 'none',
        padding: 0,
        font: 'inherit',
        fontWeight: 800,
        color: C.violetTexte,
        cursor: 'pointer',
      }}
    >
      {children}
    </button>
  );
}
